"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgStampOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.631 13c.204-1.388.614-2.193.999-2.947.453-.889.87-1.707.87-3.326C16.5 2.71 12.889 2 12 2c-.889 0-4.5.71-4.5 4.727 0 1.62.417 2.437.87 3.326.384.754.794 1.56.999 2.947H4a2 2 0 00-2 2v4h2v1.5A1.5 1.5 0 005.5 22h13a1.5 1.5 0 001.5-1.5V19h2v-4a2 2 0 00-2-2h-5.369zm-2.018 0h-1.227c-.044-.36-.1-.692-.166-1h1.56c-.066.308-.122.64-.167 1zm.82-3h-2.866a14.519 14.519 0 00-.28-.587 49.122 49.122 0 00-.135-.267C9.734 8.322 9.5 7.862 9.5 6.727c0-1.286.522-1.868 1.03-2.209.295-.197.625-.333.93-.418.149-.042.281-.068.385-.083C11.938 4.003 11.99 4 12 4c.009 0 .062.003.155.017a3.26 3.26 0 011.314.501c.509.34 1.03.923 1.03 2.21 0 1.134-.233 1.594-.652 2.418l-.135.267c-.094.188-.188.383-.28.587zM18 19v1H6v-1h12zm2-2v-2H4v2h16z' }))); };
exports.default = SvgStampOutline;
//# sourceMappingURL=StampOutline.js.map